import type { Project } from '@/lib/mockData'
import { BOND_THRESHOLD } from '@/lib/protocol'

export { BOND_THRESHOLD }

export interface BondingInfo {
  /** 0-100 progress toward the bonding threshold. */
  progressPct: number
  /** True once the curve has completed and the token has "bonded". */
  isBonded: boolean
}

export function getBondingInfo(project: Project): BondingInfo {
  if (project.type !== 'launchpad') {
    return { progressPct: 0, isBonded: false }
  }

  const supply = project.supply ?? 0
  const maxSupply = project.maxSupply ?? 0
  const rawPct = maxSupply > 0 ? (supply / maxSupply) / BOND_THRESHOLD : 0
  const progressPct = Math.min(100, Math.max(0, rawPct * 100))
  const isBonded = project.status === 'ended' || (maxSupply > 0 && supply / maxSupply >= BOND_THRESHOLD)

  return { progressPct, isBonded }
}
